
























































































































  import {Component, Vue, Watch} from 'vue-property-decorator';
  import api from '@/infrastructure/api/api';
  import download from '@/infrastructure/api/download';
  import {
    院内総在庫場所型,
    院内総在庫照会明細型,
    院内総在庫照会検索条件型,
    院内総在庫照会検索条件型バリデータ一覧,
    院内総在庫照会結果型,
  } from '@/type/stock/inhospital/item';
  import {集計種別型} from '@/type/stock/inhospital/types';
  import {
    ValidationResult,
  } from '@/type/validation/result';
  import moment from 'moment';
  import {loginModule} from '@/store/authentication/login';
  import StockItemClassSelector from '@/components/stock/item/StockItemClassSelector.vue';
  import ButtonPanel from '@/components/menu/panel/ButtonPanel.vue';
  import IconButton from '@/components/atom/button/IconButton.vue';

  import YearMonthPicker from '@/components/datepicker/YearMonthPicker.vue';
  import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
  import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
  import NormalButton from '@/components/atom/button/NormalButton.vue';
  import {progress} from '@/script/progress';
  import UsageClassSelector from '@/components/item/UsageClassSelector.vue';

  @Component({
  components: {
    YearMonthPicker,
    StockItemClassSelector,
    ButtonPanel,
    IconButton,
    AlertDialog,
    ConfirmDialog,
    NormalButton,
    UsageClassSelector,
  },
})
export default class InHospitalStock extends Vue {
  在庫場所一覧: 院内総在庫場所型[] = [];
  院内総在庫照会結果: 院内総在庫照会結果型|null = null;
  院内総在庫照会明細一覧: 院内総在庫照会明細型[] = [];
  院内総在庫照会検索条件: 院内総在庫照会検索条件型 = new 院内総在庫照会検索条件型();
  選択されている明細の部署コード: string|null = null;
  選択されている明細の商品コード: string|null = null;
  アラートメッセージ: string | string[] | null = null;
  バリデーション結果: ValidationResult = new ValidationResult(院内総在庫照会検索条件型バリデータ一覧);

  // computed
  get 管理者である(): boolean {
    return loginModule.管理者である;
  }

  get 所属部署コード(): string {
    return loginModule.部署コードを取得する;
  }

  get 全部署集計の結果が表示されている(): boolean {
    return this.院内総在庫照会結果 !== null && this.院内総在庫照会結果.ヘッダー.集計種別 === 集計種別型.全部署集計;
  }

  get Excelをダウンロードできる(): boolean {
    return 0 < this.院内総在庫照会明細一覧.length;
  }

  get 表示件数(): number {
    return this.院内総在庫照会明細一覧.length;
  }

  @Watch('院内総在庫照会検索条件.在庫場所')
  在庫場所が変更された(): void {
    const 現在年月: string = moment().format('YYYY-MM');
    this.院内総在庫照会検索条件.在庫年月 = 現在年月;
    if (this.院内総在庫照会検索条件.在庫場所 === '_all') {
      this.院内総在庫照会検索条件.集計種別 = 集計種別型.在庫場所指定なし;
    } else if (this.院内総在庫照会検索条件.在庫場所 === '_summary') {
      this.院内総在庫照会検索条件.集計種別 = 集計種別型.全部署集計;
    } else {
      this.院内総在庫照会検索条件.集計種別 = 集計種別型.在庫場所指定あり;
    }
  }

  アラートダイアログを表示する(メッセージ: string | string[]): void {
    if (typeof メッセージ === 'string') {
      this.アラートメッセージ = [メッセージ];
    } else {
      this.アラートメッセージ = メッセージ;
    }
    this.$modal.show('アラート');
  }

  Excel出力確認ダイアログを開く(): void {
    this.$modal.show('Excel出力確認ダイアログ');
  }

  Excel出力確認ダイアログを閉じる(): void {
    this.$modal.hide('Excel出力確認ダイアログ');
  }

  async 在庫場所名取得(): Promise<void> {
    try {
      this.在庫場所一覧 = await api.院内総在庫照会の在庫場所一覧を取得する();
      if (this.管理者である) {
        this.院内総在庫照会検索条件.在庫場所 = '_all';
      } else {
        this.院内総在庫照会検索条件.在庫場所 = this.所属部署コード;
      }
    } catch (error) {
      this.APIアラートメッセージを表示する(error);
    }
  }

  async 検索開始(): Promise<void> {
    if (this.バリデーション結果.hasErrors) {
      this.バリデーションエラーを表示する();
      return;
    }

    await progress(this.院内総在庫を照会する);
  }

  async 院内総在庫を照会する(): Promise<void> {
    this.明細行の選択をクリア();

    try {
      this.院内総在庫照会結果 = await api.院内総在庫を照会する(this.院内総在庫照会検索条件);
      if (this.院内総在庫照会結果 !== null) {
        this.院内総在庫照会明細一覧 = this.院内総在庫照会結果.明細一覧;
        if (this.院内総在庫照会明細一覧.length === 0) {
          this.アラートダイアログを表示する('対象データはありません');
          return;
        }
        if (this.院内総在庫照会結果.アラートメッセージ) {
          this.アラートダイアログを表示する(this.院内総在庫照会結果.アラートメッセージ);
        }
      } else {
        this.院内総在庫照会明細一覧 = [];
        this.アラートダイアログを表示する('対象データはありません');
      }
    } catch (error) {
      this.APIアラートメッセージを表示する(error);
    }
  }

  async Excelファイル出力前入力チェックをする(): Promise<void> {
    if (this.バリデーション結果.hasErrors) {
      this.バリデーションエラーを表示する();
      return;
    }

    this.Excel出力確認ダイアログを開く();
  }

  async Excelファイルを出力する(): Promise<void> {
    this.Excel出力確認ダイアログを閉じる();
    await progress(this.院内総在庫一覧表の出力);
  }

  async 院内総在庫一覧表の出力(): Promise<void> {
    await download.院内総在庫一覧表を出力する('院内総在庫一覧表.xlsx', this.院内総在庫照会検索条件);
  }

  明細行の選択をクリア(): void {
    this.選択されている明細の部署コード = null;
    this.選択されている明細の商品コード = null;
  }

  明細行を選択(院内総在庫照会明細: 院内総在庫照会明細型) {
    this.選択されている明細の部署コード = 院内総在庫照会明細.在庫場所.部署コード;
    this.選択されている明細の商品コード = 院内総在庫照会明細.商品コード;
  }

  明細行が選択されている(院内総在庫照会明細: 院内総在庫照会明細型): boolean {
    return this.選択されている明細の部署コード === 院内総在庫照会明細.在庫場所.部署コード
        && this.選択されている明細の商品コード === 院内総在庫照会明細.商品コード;
  }

  APIアラートメッセージを取得(data: any): string[] {
    let メッセージ = [data.message];
    if (!data.errors) {
      return メッセージ;
    }

    for (const エラー of data.errors) {
      メッセージ = メッセージ.concat(['・' + エラー]);
    }
    return メッセージ;
  }

  APIアラートメッセージを表示する(error: any): void {
    const APIアラートメッセージ = this.APIアラートメッセージを取得(error.data);
    this.アラートダイアログを表示する(APIアラートメッセージ);
  }

  バリデーションエラーを表示する() {
    this.アラートダイアログを表示する(this.バリデーション結果.getMessages(false));
  }

  hasError(name: string): any {
    return {'input-error': this.バリデーション結果.hasError(name)};
  }

  created(): void {
    this.在庫場所名取得();
  }

  beforeUpdate() {
    this.バリデーション結果.validate(this.院内総在庫照会検索条件);
  }
}
